<template>
  <div>
    <!-- <transition name="popChatIcon" v-if="!shouldShowChat"> -->
    <div
      class="chat-message-icon floating-chat"
      @click="
        invokeChat();
        asuoDataLayerClick('ChatUI', '0');
      "
      @mouseenter="shouldShowEllipsis = true"
      @mouseleave="shouldShowEllipsis = false"
      v-if="!shouldShowChat && !shouldUseEmbeddedMessaging"
    >
      <div :class="shouldShowEllipsis ? 'expanded-chat-icon' : 'normmal-chat-icon'">
        <svg color="inherit" class="lc-1mpchac" viewBox="0 0 32 32">
          <path
            fill="#000"
            d="M12.63,26.46H8.83a6.61,6.61,0,0,1-6.65-6.07,89.05,89.05,0,0,1,0-11.2A6.5,6.5,0,0,1,8.23,3.25a121.62,121.62,0,0,1,15.51,0A6.51,6.51,0,0,1,29.8,9.19a77.53,77.53,0,0,1,0,11.2,6.61,6.61,0,0,1-6.66,6.07H19.48L12.63,31V26.46"
          />
          <path
            :fill="shouldShowEllipsis ? '#000' : '#f9c500'"
            d="M19.57,21.68h3.67a2.08,2.08,0,0,0,2.11-1.81,89.86,89.86,0,0,0,0-10.38,1.9,1.9,0,0,0-1.84-1.74,113.15,113.15,0,0,0-15,0A1.9,1.9,0,0,0,6.71,9.49a74.92,74.92,0,0,0-.06,10.38,2,2,0,0,0,2.1,1.81h3.81V26.5Z"
            class="e1nep2br0"
            :class="shouldShowEllipsis ? 'lc-16qdtho' : 'lc-16qdtho'"
          />
        </svg>

        <div class="e1dmt1bi1" :class="shouldShowEllipsis ? 'lc-sk2jio' : 'lc-e7lz12'" v-if="shouldShowEllipsis">
          <svg viewBox="0 0 60 40" width="18px" fill="#f9c500">
            <circle r="6" cy="20" cx="9" class="dot-one epoxe490" />
            <circle r="6" cy="20" cx="30" class="dot-two epoxe490" />
            <circle r="6" cy="20" cx="51" class="dot-three epoxe490" />
          </svg>
        </div>
      </div>
    </div>
    <!-- </transition> -->
    <div
      class="chatbox-position chat"
      :style="shouldShowChat ? 'transform: scale(1)' : 'transform: scale(0)'"
      v-if="!shouldUseEmbeddedMessaging"
    >
      <transition name="fadeChatWindow" v-if="shouldShowChat && !shouldUseEmbeddedMessaging">
        <v-row no-gutters wrap style="max-width: 300px; background-color: white; border-radius: 4px 4px 0px 0px">
          <v-col cols="7" md="7" style="height: 62px; background-color: #ffc627; border-radius: 4px 0px 0px 0px">
            <div class="live-chat-box-margin live-chat-text" style="margin: 13px 0 0 24px">Live Chat</div></v-col
          >

          <v-col cols="5" md="5" style="background-color: #ffc627; border-radius: 0px 4px 0px 0px">
            <v-icon
              style="float: right; margin: 20px 20px 0 0; font-weight: 300; color: black"
              class="header-button"
              @click="
                closeChatBox();
                asuoDataLayerClick('ChatUI', '1');
              "
            >
              mdi-close
            </v-icon></v-col
          >

          <v-col cols="9" md="9" class="live-chat-box-margin" style="margin: 24px 24px 24px 24px">
            <span style="font-weight: 600">Hours</span><br />
            7 a.m. – 6 p.m. MST Monday – Friday</v-col
          >
          <v-col cols="8" md="8" class="live-chat-box-margin">
            <div v-if="isAuthenticated">
              <v-btn
                id="liveagent_button_online_5730W00000158SR"
                style="display: none; border: 0px none; cursor: pointer"
                onclick="liveagent.startChat('5730W00000158SR')"
                class="chat-now-button"
                :ripple="false"
                variant="elevated"
                rounded
                color="#FFC627"
                @click="asuoDataLayerClick('ChatUI', '2')"
                >Chat now</v-btn
              >
              <v-btn
                id="liveagent_button_offline_5730W00000158SR"
                style="display: none; border: 0px none"
                class="chat-now-button"
                :disabled="true"
                :ripple="false"
                variant="elevated"
                rounded
                color="#FFC627"
                @click="asuoDataLayerClick('ChatUI', '2')"
                >Chat now</v-btn
              >
              <span style="margin-left: 10px; color: red; font-weight: 600; font-size: 14px" v-if="shouldDisplayOffline"
                >(Offline)</span
              >
              <!-- <v-icon v-if="shouldDisplayOffline === undefined" style="color: #ffc527; margin: 6px" class="fa-spin">mdi-loading</v-icon> -->
            </div>

            <div v-else-if="!isAuthenticated && isAuthenticated !== undefined">
              <v-btn
                id="liveagent_button_online_5730W00000158SS"
                style="display: none; border: 0px none; cursor: pointer"
                onclick="liveagent.startChat('5730W00000158SS')"
                class="chat-now-button"
                :ripple="false"
                variant="elevated"
                rounded
                color="#FFC627"
                @click="asuoDataLayerClick('ChatUI', '2')"
                >Chat now</v-btn
              >
              <v-btn
                id="liveagent_button_offline_5730W00000158SS"
                style="display: none; border: 0px none"
                class="chat-now-button"
                :disabled="true"
                :ripple="false"
                variant="elevated"
                rounded
                color="#FFC627"
                @click="asuoDataLayerClick('ChatUI', '2')"
                >Chat now</v-btn
              >

              <span style="margin-left: 10px; color: red; font-weight: 600; font-size: 14px" v-if="shouldDisplayOffline"
                >(Offline)</span
              >
              <!-- <v-icon v-if="shouldDisplayOffline === undefined" style="color: #ffc527; margin: 6px" class="fa-spin">mdi-loading</v-icon> -->
            </div>
          </v-col>
          <v-col cols="8" md="8" class="live-chat-box-margin" style="margin: 24px 0 24px 24px">
            Or contact us anytime at
            <a
              href="mailto:ulcourses@asu.edu"
              target="_blank"
              style="font-weight: 600; border-bottom: 2px solid #8c1d40; cursor: pointer; color: #8c1d40"
              @click="asuoDataLayerClick('ChatUI', '3')"
              >ulcourses@asu.edu</a
            >
            <br />
            <span style="font-weight: 600">844-448-7707</span>
          </v-col>
        </v-row>
      </transition>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { useAuthStore } from '@/stores/auth';
import { useUiStore } from '@/stores/ui';
import { Logger } from '../mixins/logger.js';

import { DataLayerMixin } from '../mixins/dataLayerMixin.js';
import { Helper } from '../mixins/helpers.js';
import ConnectorService from '@/services/connector.service';

export default defineComponent({
  data() {
    return {
      shouldShowEllipsis: false,
      shouldShowChat: false,
      shouldInvokeChat: true,
      embeddedMessagingInitialized: false,
      loginEventHandler: null,
      nonAuthOnine: '',
      nonAuthOffline: '',
      authOnline: '',
      authOffline: ''
    };
  },

  mixins: [DataLayerMixin, Helper],

  computed: {
    isAuthenticated() {
      const authStore = useAuthStore();
      return authStore.auth;
    },
    shouldDisplayOffline() {
      const uiStore = useUiStore();
      return uiStore.shouldDisplayOffline;
    },
    isProduction() {
      return import.meta.env.MODE === 'production';
    },
    shouldUseEmbeddedMessaging() {
      // Only use Embedded Messaging if:
      // 1. In production mode
      // 2. On ULC domain (welcome.ulc.asu.edu)
      const partnerName = ConnectorService.getPartnerName();
      const isWelcomeDomain = partnerName === 'welcome';
      const isUlcDomain = this.isUlcPartner(); // Call the function!

      return this.isProduction && isUlcDomain && isWelcomeDomain;
    },
    isUserAuthenticated() {
      // Multiple checks for reliable auth state detection
      // This is critical for ensuring dashboard users get authenticated deployment

      // Check 1: Auth service check
      const authServiceCheck = this.$auth && this.$auth.isAuthenticated();

      // Check 2: AuthStore check (use getter for reliability)
      const authStore = useAuthStore();
      const authStoreCheck = authStore.isAuthenticated;

      // Check 3: Check if user ID exists in auth service
      const userIdCheck = this.$auth && this.$auth.getUserId();

      // Return true if any check indicates authentication
      return authServiceCheck || authStoreCheck || !!userIdCheck;
    }
  },

  mounted() {
    if (this.shouldUseEmbeddedMessaging) {
      // Production + ULC domain: Use new Embedded Messaging
      this.initializeEmbeddedMessagingForProduction();
    } else {
      // Development/Staging or non-ULC domains: Prevent Embedded Messaging conflicts
      this.cleanupEmbeddedMessagingScripts();
    }
  },

  watch: {
    isUserAuthenticated(newVal, oldVal) {
      // Watch for auth state changes and reinitialize if needed
      if (this.shouldUseEmbeddedMessaging && newVal !== oldVal) {
        // Clean up and reinitialize with correct deployment
        this.cleanupEmbeddedMessagingScripts();
        setTimeout(() => {
          this.initializeEmbeddedMessagingForProduction();
        }, 100);
      }
    }
  },

  beforeUnmount() {
    // Clean up auth event listener
    if (this.$auth && this.loginEventHandler) {
      this.$auth.removeListener('loginEvent', this.loginEventHandler);
    }
  },

  methods: {
    initializeEmbeddedMessagingForProduction() {
      const uiStore = useUiStore();

      // Use improved multi-source auth detection
      // This ensures dashboard users always get the authenticated deployment
      const isAuthenticated = this.isUserAuthenticated;

      // Call with current auth state
      this.initEmbeddedMessaging(isAuthenticated, uiStore);

      // Listen for auth manager login events (like Dashboard.vue pattern)
      if (this.$auth) {
        this.loginEventHandler = () => {
          // Only reinitialize if not already loading/initialized
          if (!window.embeddedMessagingActivelyLoading && !window.embeddedMessagingInitialized) {
            // Clean up existing scripts and reset
            this.cleanupEmbeddedMessagingScripts();

            // Wait a bit for cleanup to complete, then initialize as authenticated user
            setTimeout(() => {
              this.initEmbeddedMessaging(true, uiStore);
            }, 100);
          }
        };

        this.$auth.addListener('loginEvent', this.loginEventHandler);
      }
    },
    closeChatBox() {
      if (typeof liveagent !== 'undefined') {
        const authStore = useAuthStore();
        if (!authStore.auth) {
          this.nonAuthOffline = this.getStyleFromHTMLElement(
            document.getElementById('liveagent_button_offline_5730W00000158SS').outerHTML
          );

          this.nonAuthOnine = this.getStyleFromHTMLElement(
            document.getElementById('liveagent_button_online_5730W00000158SS').outerHTML
          );
        } else {
          this.authOnline = this.getStyleFromHTMLElement(
            document.getElementById('liveagent_button_online_5730W00000158SR').outerHTML
          );
          this.authOffline = this.getStyleFromHTMLElement(
            document.getElementById('liveagent_button_offline_5730W00000158SR').outerHTML
          );
        }
        this.shouldShowChat = false;
        this.shouldShowEllipsis = false;
      }
    },
    getStyleFromHTMLElement(htmlText) {
      htmlText = htmlText.substring(htmlText.indexOf('style') + 7, htmlText.length);
      htmlText = htmlText.substring(0, htmlText.indexOf('"'));
      return htmlText;
    },
    invokeChat() {
      this.shouldShowChat = true;
      if (typeof liveagent !== 'undefined' && this.shouldInvokeChat) {
        const authStore = useAuthStore();
        const uiStore = useUiStore();
        if (!authStore.auth) {
          if (!window._laq) {
            window._laq = [];
          }
          window._laq.push(function () {
            // eslint-disable-next-line no-undef
            liveagent.showWhenOnline(
              '5730W00000158SS',
              document.getElementById('liveagent_button_online_5730W00000158SS')
            );
            // eslint-disable-next-line no-undef
            liveagent.showWhenOffline(
              '5730W00000158SS',
              document.getElementById('liveagent_button_offline_5730W00000158SS')
            );
          });
          // eslint-disable-next-line no-undef
          liveagent.init('https://d.la4-c2-ia4.salesforceliveagent.com/chat', '5720W0000010wFS', '00Dd0000000hLoc');

          let self = this;

          setTimeout(function () {
            self.nonAuthOffline = self.getStyleFromHTMLElement(
              document.getElementById('liveagent_button_offline_5730W00000158SS').outerHTML
            );
            self.nonAuthOnine = self.getStyleFromHTMLElement(
              document.getElementById('liveagent_button_online_5730W00000158SS').outerHTML
            );
            document.getElementById('liveagent_button_offline_5730W00000158SS').style.cssText = self.nonAuthOffline;
            document.getElementById('liveagent_button_online_5730W00000158SS').style.cssText = self.nonAuthOnine;
            if (!self.nonAuthOffline.includes('display: none')) uiStore.setDisplayOfflineText(true);
            if (
              !document.getElementById('liveagent_button_offline_5730W00000158SS').outerHTML.includes('display: none')
            )
              uiStore.setDisplayOfflineText(true);
          }, 2000);
        } else {
          if (!window._laq) {
            window._laq = [];
          }
          window._laq.push(function () {
            // eslint-disable-next-line no-undef
            liveagent.showWhenOnline(
              '5730W00000158SR',
              document.getElementById('liveagent_button_online_5730W00000158SR')
            );
            // eslint-disable-next-line no-undef
            liveagent.showWhenOffline(
              '5730W00000158SR',
              document.getElementById('liveagent_button_offline_5730W00000158SR')
            );
          });
          // eslint-disable-next-line no-undef
          liveagent.init('https://d.la4-c2-ia4.salesforceliveagent.com/chat', '5720W0000010wFR', '00Dd0000000hLoc');

          let self = this;

          setTimeout(function () {
            self.authOnline = self.getStyleFromHTMLElement(
              document.getElementById('liveagent_button_online_5730W00000158SR').outerHTML
            );
            self.authOffline = self.getStyleFromHTMLElement(
              document.getElementById('liveagent_button_offline_5730W00000158SR').outerHTML
            );
            document.getElementById('liveagent_button_online_5730W00000158SR').style.cssText = self.authOnline;
            document.getElementById('liveagent_button_offline_5730W00000158SR').style.cssText = self.authOffline;
            if (!self.authOffline.includes('display: none')) uiStore.setDisplayOfflineText(true);
            if (
              !document.getElementById('liveagent_button_offline_5730W00000158SR').outerHTML.includes('display: none')
            )
              uiStore.setDisplayOfflineText(true);
          }, 2000);
        }
        this.shouldInvokeChat = false;
      }
    },

    cleanupEmbeddedMessagingScripts() {
      // Increment cleanup counter to invalidate old script callbacks
      window.embeddedMessagingCleanupCounter = (window.embeddedMessagingCleanupCounter || 0) + 1;

      // Remove event listeners
      const oldHandler = window.onEmbeddedMessagingReadyHandler;
      if (oldHandler) {
        window.removeEventListener('onEmbeddedMessagingReady', oldHandler);
        delete window.onEmbeddedMessagingReadyHandler;
      }

      // Remove scripts
      const scripts = document.querySelectorAll('script');
      scripts.forEach((script) => {
        if (
          script.src &&
          (script.src.includes('asu.my.site.com') ||
            script.src.includes('salesforce') ||
            script.src.includes('embeddedservice') ||
            script.src.includes('bootstrap.min.js'))
        ) {
          script.remove();
        }
      });

      // Remove DOM elements
      const embeddedElements = document.querySelectorAll(
        '[class*="embeddedMessaging"], [class*="embedded-messaging"], [class*="siteContextFrame"], [id*="embeddedMessaging"], [id*="embedded-messaging"]'
      );
      embeddedElements.forEach((el) => el.remove());

      // Clear globals
      window.embeddedservice_bootstrap = undefined;
      window.embedded_svc = undefined;
      window.embeddedMessagingActivelyLoading = false;
      window.embeddedMessagingInitialized = false;
      this.embeddedMessagingInitialized = false;

      // Remove event listeners
      const events = ['onEmbeddedMessagingReady'];
      events.forEach((eventName) => {
        if (window[eventName]) {
          delete window[eventName];
        }
      });
    },

    initEmbeddedMessaging(isAuth, uiStore) {
      // Prevent duplicate initialization
      if (this.embeddedMessagingInitialized || window.embeddedMessagingActivelyLoading) {
        return;
      }

      // Global flag to prevent multiple instances across components
      window.embeddedMessagingActivelyLoading = true;

      // Store the handler so we can remove it later during cleanup
      const embeddedMessagingReadyHandler = function () {
        // Set prechat fields
        window.embeddedservice_bootstrap.prechatAPI.setHiddenPrechatFields({
          ReferringURL: window.location.href
        });

        // Append CSS to iframe for mobile z-index fix
        var style = document.createElement('style');
        style.innerHTML = `
          @media only screen and (min-width: 15em) and (max-width: 47.9375em) {
            .embedded-messaging .embeddedMessagingFrame.isMaximized {
              z-index: 1035 !important;
            }
          }
        `;
        window.embeddedservice_bootstrap.siteContextFrame.append(style);

        // Set offline status based on availability
        setTimeout(function () {
          uiStore.setDisplayOfflineText(false);
        }, 2000);
      };

      // Store handler reference globally so cleanup can access it
      window.onEmbeddedMessagingReadyHandler = embeddedMessagingReadyHandler;

      // Add event listener for onEmbeddedMessagingReady
      window.addEventListener('onEmbeddedMessagingReady', embeddedMessagingReadyHandler);

      const scriptSrc = isAuth
        ? `${import.meta.env.VITE_EMBEDDED_MESSAGING_AUTH_SITE}/assets/js/bootstrap.min.js`
        : `${import.meta.env.VITE_EMBEDDED_MESSAGING_NON_AUTH_SITE}/assets/js/bootstrap.min.js`;

      const deploymentName = isAuth
        ? import.meta.env.VITE_EMBEDDED_MESSAGING_AUTH_DEPLOYMENT
        : import.meta.env.VITE_EMBEDDED_MESSAGING_NON_AUTH_DEPLOYMENT;

      const siteURL = isAuth
        ? import.meta.env.VITE_EMBEDDED_MESSAGING_AUTH_SITE
        : import.meta.env.VITE_EMBEDDED_MESSAGING_NON_AUTH_SITE;

      // Check if script already exists or if bootstrap is already loaded
      const existingScript = document.querySelector(`script[src="${scriptSrc}"]`);
      const bootstrapAlreadyLoaded =
        window.embeddedservice_bootstrap !== undefined && window.embeddedservice_bootstrap !== null;

      if (!existingScript && !bootstrapAlreadyLoaded) {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = scriptSrc;

        // Store deployment info and cleanup counter to verify in callback
        const callbackDeploymentInfo = {
          deploymentName,
          siteURL,
          cleanupCounter: window.embeddedMessagingCleanupCounter || 0
        };

        script.onload = function () {
          // Check if this callback is still valid (not cleaned up)
          const currentCleanupCounter = window.embeddedMessagingCleanupCounter || 0;
          if (callbackDeploymentInfo.cleanupCounter !== currentCleanupCounter) {
            // Stale callback - ignore it
            return;
          }

          try {
            // Clear the loading flag once loaded
            window.embeddedMessagingActivelyLoading = false;

            if (window.embeddedservice_bootstrap && !window.embeddedMessagingInitialized) {
              window.embeddedservice_bootstrap.settings.language = 'en_US';

              window.embeddedservice_bootstrap.init(
                import.meta.env.VITE_EMBEDDED_MESSAGING_ORG_ID,
                callbackDeploymentInfo.deploymentName,
                callbackDeploymentInfo.siteURL,
                {
                  scrt2URL: import.meta.env.VITE_EMBEDDED_MESSAGING_SCRT_URL
                }
              );

              // Set flags AFTER init succeeds
              window.embeddedMessagingInitialized = true;
              this.embeddedMessagingInitialized = true;
            }
          } catch (err) {
            window.embeddedMessagingActivelyLoading = false;
            Logger.methods.logError('Error initializing Embedded Messaging:', err);
          }
        };

        script.onerror = function () {
          window.embeddedMessagingActivelyLoading = false;
        };

        document.body.appendChild(script);
      } else {
        // Script or bootstrap already exists, clear loading flag
        window.embeddedMessagingActivelyLoading = false;

        // Only initialize if not already done
        if (bootstrapAlreadyLoaded && !window.embeddedMessagingInitialized) {
          try {
            window.embeddedservice_bootstrap.settings.language = 'en_US';

            window.embeddedservice_bootstrap.init(
              import.meta.env.VITE_EMBEDDED_MESSAGING_ORG_ID,
              deploymentName,
              siteURL,
              {
                scrt2URL: import.meta.env.VITE_EMBEDDED_MESSAGING_SCRT_URL
              }
            );

            // Set flags AFTER init succeeds
            window.embeddedMessagingInitialized = true;
            this.embeddedMessagingInitialized = true;
          } catch (err) {
            Logger.methods.logError('Error reinitializing Embedded Messaging:', err);
          }
        }
      }
    }
  },

  updated() {
    // Only run Live Agent updates when NOT using Embedded Messaging
    if (!this.shouldUseEmbeddedMessaging) {
      const authStore = useAuthStore();
      const uiStore = useUiStore();
      if (
        !authStore.auth &&
        this.nonAuthOffline &&
        document.getElementById('liveagent_button_offline_5730W00000158SS') != null
      ) {
        document.getElementById('liveagent_button_offline_5730W00000158SS').style.cssText = this.nonAuthOffline;
        document.getElementById('liveagent_button_online_5730W00000158SS').style.cssText = this.nonAuthOnine;
        if (!this.nonAuthOffline.includes('display: none')) {
          uiStore.setDisplayOfflineText(true);
        } else {
          uiStore.setDisplayOfflineText(false);
        }
      } else if (this.authOnline && document.getElementById('liveagent_button_online_5730W00000158SR') != null) {
        document.getElementById('liveagent_button_online_5730W00000158SR').style.cssText = this.authOnline;
        document.getElementById('liveagent_button_offline_5730W00000158SR').style.cssText = this.authOffline;
        if (!this.authOffline.includes('display: none')) {
          uiStore.setDisplayOfflineText(true);
        } else {
          uiStore.setDisplayOfflineText(false);
        }
      }
    }
  }
});
</script>

<style lang="stylus">
// floating-chat

// Imports
// --------------------------------------
// Variables
// --------------------------------------
scrollbar-width = 5px;
chat-thread-bgd-color = rgba(25, 147, 147, 0.2);
chat-thread-msg-arrow-size = 10px;
chat-thread-avatar-size = 25px;
chat-thread-offset = chat-thread-avatar-size + 20px;
default-shadow-color = rgb(0, 0, 0);

.floating-chat {
  transition: all 0.1s cubic-bezier(0.18, 0.89, 0.32, 1.28);

  &.expand {
    width: 300px;
    height: 336px;
    right: 16px;
    border-radius: 0px;
    cursor: auto;
    opacity: 1;
  }
}

.chat-message-icon {
  background-color: rgb(255, 198, 39);
  position: fixed;
  right: 16px;
  bottom: 16px;
  z-index: 999;
  padding: 15px 15px 15px;
  border-radius: 40px;
  box-shadow: rgba(0, 0, 0, 0.3) 0px 4px 12px;
  cursor: pointer;
}

.chat-message-icon:active {
  animation: chat-icon-animation-onclick 0.2s forwards linear;
}

@keyframes chat-icon-animation-onclick {
  0% {
  }

  50% {
    transform-origin: bottom right;
    transform: scale(1.2);
    opacity: 0.5;
  }

  100% {
    opacity: 0;
  }
}

.chat {
  &.expand {
    // width: 300px;
    // height: 336px;
    border-radius: 5px;
    cursor: auto;
    opacity: 1;
  }
}

.chatbox-position {
  position: fixed;
  right: 16px;
  bottom: 16px;
  z-index: 999;
  max-height: 360px;
  box-shadow: rgba(0, 0, 0, 0.3) -6px 4px 20px;
  background: white;
  transition: transform 0.3s ease;
  transform-origin: bottom right;
  border-radius: 4px 4px 0px 0px;
}

.chat-now-button {
  font-weight: bold;
  border-radius: 30px !important;
  margin: 0 24px 24px 0;
  font-size: 16px !important;
  height: 43px !important;
  width: 115px;
  font-weight: 600 !important;
  margin: 0 !important;
}

.fadeChatWindow-enter-active, .fadeChatWindow-leave-active {
  transition: opacity 1s;
}

.fadeChatWindow-enter, .fadeChatWindow-leave-to {
  opacity: 0;
}

.popChatIcon-enter-active, .popChatIcon-leave-active {
  transition: transform 0.1s cubic-bezier(0.4, 0, 1, 1), opacity 2s;
}

.popChatIcon-enter, .popChatIcon-leave-to {
  transform: translateY(20px);
  opacity: 0;
}

@keyframes chatwindow-fadein {
  0% {
    opacity: 0;
  }

  50% {
    opacity: 0.2;
  }

  100% {
    opacity: 1;
  }
}

.normmal-chat-icon {
  position: relative;
  transition: transform 200ms cubic-bezier(0.18, 0.89, 0.32, 1.28) 50ms;
  display: flex;
  width: 32px;
  height: 32px;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  transform: scale(1);
}

.expanded-chat-icon {
  position: relative;
  transition: transform 200ms cubic-bezier(0.18, 0.89, 0.32, 1.28) 50ms;
  display: flex;
  width: 32px;
  height: 32px;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  transform: scale(1.25);
}

.lc-1mpchac {
  display: inline-block;
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  font-size: 2rem;
  user-select: none;
  fill: currentcolor;
  cursor: pointer;
}

.lc-e7lz12 {
  /* position: absolute; */
  z-index: 1;
  left: 0px;
  right: 0px;
  bottom: 1px;
  transition: opacity 150ms cubic-bezier(0.33, 0, 0.67, 1) 50ms;
  display: flex;
  width: 32px;
  height: 32px;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  /* opacity: 0; */
}

.lc-sk2jio {
  position: absolute;
  z-index: 1;
  left: 0px;
  right: 0px;
  bottom: 1px;
  transition: opacity 150ms cubic-bezier(0.33, 0, 0.67, 1) 50ms;
  display: flex;
  width: 32px;
  height: 32px;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  opacity: 1;
}

.lc-12xrwyz {
  opacity: 0;
  transform: scale(0);
  transform-origin: 50% 50%;
  transition: all 200ms cubic-bezier(0.18, 0.89, 0.32, 1.28) 50ms;
}

.lc-16qdtho {
  opacity: 1;
  transform: scale(1);
  transform-origin: 50% 50%;
  transition: all 200ms cubic-bezier(0.18, 0.89, 0.32, 1.28) 50ms;
}

// Three dots
.dot-one {
  transform-box: fill-box;
  transform-origin: 50% 50%;
  animation-timing-function: cubic-bezier(0, 0, 1, 1);
  animation-name: animation-dot-one;
  animation-duration: 1s;
  animation-iteration-count: 1;
}

.dot-two {
  transform-box: fill-box;
  transform-origin: 50% 50%;
  animation-timing-function: cubic-bezier(0, 0, 1, 1);
  animation-name: animation-dot-two;
  animation-duration: 1s;
  animation-iteration-count: 1;
}

.dot-three {
  transform-box: fill-box;
  transform-origin: 50% 50%;
  animation-timing-function: cubic-bezier(0, 0, 1, 1);
  animation-name: animation-dot-three;
  animation-duration: 1s;
  animation-iteration-count: 1;
}

@keyframes animation-dot-one {
  0%, 6.67% {
    transform: translate(0px, -8px);
  }

  13.33%, 20% {
    transform: translate(0px, -10px);
  }

  26.67% {
    transform: translate(0px, -6px);
  }

  33.33% {
    transform: translate(0px, -2px);
  }

  40% {
    transform: translate(0px, 3px);
  }

  46.67% {
    transform: translate(0px, 2px);
  }

  53.33% {
    transform: translate(0px, -1px);
  }

  66.67%, 100% {
    transform: translate(0px, 0px);
  }
}

@keyframes animation-dot-two {
  0%, 6.67%, 73.33%, 100% {
    transform: translate(0px, 0px);
  }

  13.33% {
    transform: translate(0px, -8px);
  }

  20%, 26.67% {
    transform: translate(0px, -10px);
  }

  33.33% {
    transform: translate(0px, -6px);
  }

  40% {
    transform: translate(0px, -2px);
  }

  46.67% {
    transform: translate(0px, 3px);
  }

  53.33% {
    transform: translate(0px, 2px);
  }

  60% {
    transform: translate(0px, -1px);
  }
}

@keyframes animation-dot-three {
  0%, 13.33%, 80%, 100% {
    transform: translate(0px, 0px);
  }

  20% {
    transform: translate(0px, -8px);
  }

  26.67%, 33.33% {
    transform: translate(0px, -10px);
  }

  40% {
    transform: translate(0px, -6px);
  }

  46.67% {
    transform: translate(0px, -2px);
  }

  53.33% {
    transform: translate(0px, 3px);
  }

  60% {
    transform: translate(0px, 2px);
  }

  66.67% {
    transform: translate(0px, -1px);
  }
}
</style>
